import script from "./AppMenuLogo.vue?vue&type=script&setup=true&lang=js"
export * from "./AppMenuLogo.vue?vue&type=script&setup=true&lang=js"

import "./AppMenuLogo.vue?vue&type=style&index=0&id=7ee6ffa6&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7ee6ffa6"]])

export default __exports__